import React from "react";
import classNames from "classnames";
import {
  getViralSubstitutionMarker,
  getViralDeletionMarker,
  getViralInsertionMarker,
} from "../../utils/polygons";
import { GenomicVariant } from "../../api";

type VariantAction = (variant: GenomicVariant) => void;

interface Props {
  selected: boolean;
  variant: GenomicVariant;
  scale: number;
  scrollLeftPosition: number;
  onClick: VariantAction;
}

export function ViralVariantMarker(props: Props) {
  function onClick() {
    props.onClick(props.variant);
  }

  function getTooltipText(): string {
    return props.variant.gene_name || "–";
  }

  function getMarkerPoints(): string {
    const baseX = props.scrollLeftPosition;
    const baseY = 20;
    const baseOffset = 7;
    // TODO: make variant type an enum
    const variantType = props.variant.variant_type;
    if (variantType === "Substitution") {
      return getViralSubstitutionMarker(baseX, baseY, 6);
    }
    if (variantType === "Deletion") {
      return getViralDeletionMarker(baseX, baseY - 3, baseOffset);
    }
    return getViralInsertionMarker(baseX, baseY + 3, baseOffset);
  }

  function getFillColor(): string {
    return "lightgray";
  }

  const classes = classNames(["annotation-polygon", "variant-polygon"], {
    "annotation-polygon--selected": props.selected,
  });

  const markerPoints = getMarkerPoints();
  const fillColor = getFillColor();
  return (
    <polygon
      points={markerPoints}
      style={{
        fill: fillColor,
        opacity: 0.8,
      }}
      className={classes}
      onClick={onClick}
    >
      <title>{getTooltipText()}</title>
    </polygon>
  );
}
